import { pluralize } from '@cian/newbuilding-utils';
import { Header2, InlineText1 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { CoworkingProfitBanner } from '../CoworkingProfitBanner';

import { WorkplaceInCoworkingHeaderProps } from './types';

import * as styles from './WorkplaceInCoworkingHeader.css';

export const WorkplaceInCoworkingHeader: FC<WorkplaceInCoworkingHeaderProps> = props => {
  const { price, count, title } = props;

  return (
    <div className={styles['container']}>
      <Header2>{title}</Header2>
      <div className={styles['cost-container']}>
        <div className={styles['cost']}>
          <Header2>{numberToPrettyString(price)} ₽/мес.</Header2>
        </div>
        <CoworkingProfitBanner />
      </div>
      <InlineText1>{`Доступно ${pluralize(count, ['место', 'места', 'мест'])}`}</InlineText1>
    </div>
  );
};

WorkplaceInCoworkingHeader.displayName = 'WorkplaceInCoworkingHeader';
